import { getCustomerAPI } from '~/utils/api'
import HTTPError from '~/utils/http-error'
import { reportGroupedError } from '~/utils/logger'

export const removeSheerIdAssociation = async (
  cartItemInternalId: string,
): Promise<boolean> => {
  try {
    const api = getCustomerAPI()
    const response = await api.removeProfileAffiliation(cartItemInternalId)

    if (!response.ok) {
      throw new HTTPError(
        'SheerId removal failed',
        response,
        await response.text(),
      )
    }
  } catch (error) {
    if (error) {
      reportGroupedError('removeSheerIdAssociation', error)
    }
    return false
  }
  return true
}
